import React from 'react';
import { COMP_INFO } from '../../config';


const Footer = () => {
  return (
    <>
      <footer id="footer">
        <div className="footer text-center">
          <div className="footer-inner">
            Copyright © {new Date().getFullYear()}  {COMP_INFO.NAME} All Rights Reserved.
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer;